import type {
  ClientCancellationLineReason,
  ClientCancellationLineStatus,
} from '../../types/clientCancellationLines';

export const CLIENT_CANCELLATION_SUSPENSION_BLOCK_MESSAGE =
  "Suspensao desativada: o proprio cliente deve cancelar ligando no 1056. Registre a linha em 'Linhas para cancelamento pelo cliente'.";

export const CLIENT_CANCELLATION_TIM_1056_SCRIPT = [
  'Oriente o cliente a ligar para a TIM no 1056 e solicitar o cancelamento da linha informada.',
  'Confirme que a ligação partiu do titular ou representante autorizado.',
  'Registre aqui o andamento (cliente avisado, cancelamento confirmado ou recusa).',
].join('\n');

const REASON_LABELS: Record<ClientCancellationLineReason, string> = {
  Zerada: 'Linha zerada',
  SemUso0a4Meses: 'Sem uso (0 a 4 meses)',
  Outro: 'Outro motivo',
};

const STATUS_LABELS: Record<ClientCancellationLineStatus, string> = {
  Agendado: 'Agendado',
  ClienteAvisado: 'Cliente avisado',
  CancelamentoConfirmado: 'Cancelamento confirmado',
  NaoCancelou: 'Não cancelou',
  Encerrado: 'Encerrado',
};

export function labelClientCancellationReason(reason: ClientCancellationLineReason): string {
  return REASON_LABELS[reason] ?? reason;
}

export function labelClientCancellationStatus(status: ClientCancellationLineStatus): string {
  return STATUS_LABELS[status] ?? status;
}

export function clientCancellationReasonOptions(): Array<{ value: ClientCancellationLineReason; text: string }> {
  return (Object.keys(REASON_LABELS) as ClientCancellationLineReason[]).map((value) => ({
    value,
    text: REASON_LABELS[value],
  }));
}
